import Feature from '../../admin/Feature'
import { Link } from 'react-router-dom'

const TileMain = ({colorClass, iconClass, title, text}) => {
    return(
        <div className={colorClass}>
                <div className="icon">
                    <i className={iconClass}></i>
                </div>
                <div className="num-small">{title}</div>
                <p>{text}</p>
        </div>
    )
}

const TileSmall = ({colorClass, text, url}) => {
    return(
        <div className={colorClass}>
            <Link to={url}>
                <p>{text}</p>
            </Link>
        </div>
    )
}

const ReportsIndex = () => {
    return(
        <div>
        <div className="row">
            <div className="col-md-12">
                <h2>Reports Index</h2>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-12 col-xs-12">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="col-sm-4 col-xs-12">
                            <Feature name="voice-wholesale">
                                <TileMain colorClass="tile-aqua tile-stats" iconClass="icon-phone" title="Voice Reports" text="Voice Reports" />
                            </Feature>
                            <Feature name="sms-wholesale">
                                <TileMain colorClass="tile-aqua tile-stats" iconClass="icon-chat" title="SMS Reports" text="SMS Reports" />
                                <TileSmall colorClass="tile-white tile-stats" url="/reports/sms/summary" text="SMS Summary" />
                                <TileSmall colorClass="tile-white tile-stats" url="/reports/sms/smslog" text="SMS Log" />
                                <TileSmall colorClass="tile-white tile-stats" url="/reports/sms/surcharges" text="SMS Surcharges" />
                            </Feature>
                        </div>
                        <div className="col-sm-4 col-xs-12">
                            <TileMain colorClass="tile-aqua tile-stats" iconClass="icon-doc-text" title="Invoices Reports" text="Invoices Reports" />
                            <TileSmall colorClass="tile-white tile-stats" url="/reports/invoices" text="Invoices" />

                        </div>
                        <div className="col-sm-4 col-xs-12">
                            <TileMain colorClass="tile-aqua tile-stats" iconClass="icon-credit-card" title="Payments Reports" text="Payments Reports" />
                            <TileSmall colorClass="tile-white tile-stats" url="/reports/payments" text="Payments" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};  

export default ReportsIndex;